export default __webpack_public_path__ + "static/media/delete.51018ff0.png";